// /* eslint-disable import/no-dynamic-require */
// const config = require(`./${process.env.REACT_APP_MODE || 'local'}`);
// export const isProduction = () => process.env.REACT_APP_MODE === 'production';
// export default config.default;
import localConfig from './local';
import productionConfig from './production';

const mode = process.env.REACT_APP_MODE || 'local';

let config;

switch (mode) {
  case 'production':
    config = productionConfig;
    break;
  case 'local':
  default:
    config = localConfig;
    break;
}

export const isProduction = () => mode === 'production';
export default config;
